import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

const navLinks = [
  { label: "Rates", href: "/rates" },
  { label: "Industries", href: "/industries" },
  { label: "Markets", href: "/markets" },
  { label: "Contact", href: "/contact" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { user, isAdmin, signOut } = useAuth();

  return (
    <header className="border-b border-border bg-background">
      <div className="container flex items-center justify-between h-14">
        <Link to="/" className="font-display font-semibold text-lg tracking-tight text-foreground">
          PowerRate
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-body font-medium transition-colors hover:text-foreground ${
                location.pathname === link.href ? "text-foreground" : "text-muted-foreground"
              }`}
            >
              {link.label}
            </Link>
          ))}
          {user ? (
            <>
              <Link to="/dashboard" className="text-sm font-body font-medium text-muted-foreground hover:text-foreground">
                Dashboard
              </Link>
              {isAdmin && (
                <Link to="/admin" className="text-sm font-body font-medium text-muted-foreground hover:text-foreground">
                  Admin
                </Link>
              )}
              <Button variant="outline" size="sm" onClick={signOut}>
                Logout
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-body font-medium text-muted-foreground hover:text-foreground">
                Login
              </Link>
              <Button variant="action" size="sm" asChild>
                <Link to="/upload">Upload Bill</Link>
              </Button>
            </>
          )}
        </nav>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-foreground font-body text-sm font-medium"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? "Close" : "Menu"}
        </button>
      </div>

      {/* Mobile nav */}
      {menuOpen && (
        <nav className="md:hidden border-t border-border bg-background px-4 pb-4 pt-2 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-sm font-body font-medium text-muted-foreground hover:text-foreground"
            >
              {link.label}
            </Link>
          ))}
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="text-sm font-body font-medium text-muted-foreground hover:text-foreground">
                Dashboard
              </Link>
              {isAdmin && (
                <Link to="/admin" onClick={() => setMenuOpen(false)} className="text-sm font-body font-medium text-muted-foreground hover:text-foreground">
                  Admin
                </Link>
              )}
              <Button variant="outline" size="sm" onClick={() => { signOut(); setMenuOpen(false); }} className="w-fit">
                Logout
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMenuOpen(false)} className="text-sm font-body font-medium text-muted-foreground hover:text-foreground">
                Login
              </Link>
              <Button variant="action" size="sm" asChild className="w-fit">
                <Link to="/upload" onClick={() => setMenuOpen(false)}>Upload Bill</Link>
              </Button>
            </>
          )}
        </nav>
      )}
    </header>
  );
}
